import React, { Component } from 'react'
import { observer } from 'mobx-react'
import SearchBar from './SearchBar'
import Table from './Table'
import style from '../style.module.less'

@observer
export default class extends Component {
  render() {
    return (
      <div className={style.table}>
        <SearchBar {...this.props} />
        <Table {...this.props} />
      </div>
    )
  }
}
